import { gql, TypedDocumentNode } from '@apollo/client';
import { backendResponse } from '../../../common_lib_front/types/backendResponse';
import PassInfo, { newPassInfo } from '../../../common_lib_front/types/passInfo';
import VehicleInfo, { newVehicleInfo, VehicleInfoConfig } from '../../../common_lib_front/types/vehicleInfo';

export const mapVehicleInfoToEditData = (data: VehicleInfo) => ({
  color: data.color || undefined,
  destinationAddressId: data.destinationAddressId || undefined,
  isRental: data.isRental || undefined,
  licensePlate: data.licensePlate || undefined,
  licensePlateState: data.licensePlateState || undefined,
  licensePrimaryDriver: data.licensePrimaryDriver || undefined,
  make: data.make || undefined,
  primaryDriverName: data.primaryDriverName || undefined,
  type: data.type || undefined,
  vehicleModel: data.vehicleModel || undefined,
  year: data.year || undefined,
});


export type MARK_VEHICLE_NON_RENTAL_VARS = {
  vehicleId: string;
  newVehicleInfo: ReturnType<typeof mapVehicleInfoToEditData>;
};
export type MARK_VEHICLE_NON_RENTAL_RES = {
  editVehicle: backendResponse<undefined>
};
export const MARK_VEHICLE_NON_RENTAL: TypedDocumentNode<
  MARK_VEHICLE_NON_RENTAL_RES,
  MARK_VEHICLE_NON_RENTAL_VARS
> = gql`
  mutation EditVehicle(
    $newVehicleInfo: ActuallyInputTypeVehicleInput!
    $vehicleId: String!
  ) {
    editVehicle(newVehicleInfo: $newVehicleInfo, vehicleId: $vehicleId) {
      success
      error
      data {
        vehicleId
      }
    }
  }
`;

export type COMPLETE_PASS_VARS = {
  passId: string;
};
export type COMPLETE_PASS_RES = {
  editPassStatus: backendResponse<undefined>;
};
export const COMPLETE_PASS: TypedDocumentNode<
  COMPLETE_PASS_RES,
  COMPLETE_PASS_VARS
> = gql`
  mutation EditPassStatus($passId: String!) {
    editPassStatus(passId: $passId, status: "inactive") {
      success
      error
    }
  }
`;

export function canCompletePass(pass: PassInfo, config: VehicleInfoConfig): boolean {
  if (!config) {
    return false;
  }
  return Object.entries(config).every(
    ([fieldName, reqirementStatus]) =>
      reqirementStatus !== 'required' ||
      pass.vehicle[fieldName] === 0 ||
      typeof pass.vehicle[fieldName] === 'boolean' ||
      Boolean(pass.vehicle[fieldName]),
  );
}

export function completeRentalPass(pass: PassInfo): PassInfo {
  if (pass.status !== 'incomplete' && pass.status !== 'incomplete-rental-car') {
    throw Error('Cannot complete a pass that is not incomplete');
  }
  return newPassInfo({
    ...pass,
    status: 'inactive',
    vehicle: newVehicleInfo({
      ...pass.vehicle,
      isRental: false,
    }),
  });
}